import { useLocation } from 'react-router-dom'
import { Helmet as HelmetBase } from 'react-helmet'

const Helmet = HelmetBase as unknown as React.ComponentType<any>

export const HelmetTitleUpdater = () => {
  const location = useLocation()
  const titles: Record<string, string> = {
    '/': 'Sentinela',
    '/app/enrollment-sed': 'Matrícula Online',
    '/app/patch-notes': 'Notas de Atualização',
    '/app/system-information': 'Sistema e Informações',
    '/app/educational-unit/geo/update': 'Cadastro de Unidade de Ensino',
    '/app/neighborhoods': 'Cadastro de Bairros',
    '/app/health-units': 'Cadastro de Unidades de Saúde',
    '/app/health-teams': 'Cadastro de Equipes de Saúde',
    '/app/health-professionals': 'Cadastro de Agentes de Saúde',
    '/app/zoning/school': 'Zoneamento Escolar',
    '/app/student/transport-arrange': 'Transporte Escolar',
    '/citizen/geo/update': 'Edição de Localização de Cidadão',
    '/app/sentinel': 'Sentinela',
    '/app/insights': 'Insights',
  }

  const favicons: Record<string, string> = {
    '/': '/public/favicon.ico',
    '/app/enrollment-sed': '/assets/favicon.svg',
  }

  const title = titles[location.pathname] || 'Prix Tech'

  const favicon = favicons[location.pathname] || '/public/favicon.ico'

  return (
    <Helmet>
      <title>{title}</title>
      <link rel='icon' type='image/x-icon' href={favicon} />
    </Helmet>
  )
}
